import React from "react";
import BaseThemeBasePage from "./BasePage";
import PromotionalBanner from "@menu/components/PromotionalBanner";
import useRouter from "src/core/common/hooks/useRouter";
import useAdBanner from "src/core/common/hooks/useAdBanner";
import useBrand from "src/menu/hooks/useBrand";
import {PageHead} from "src/core/seo/components/Head";
import BrandDetailSchema from "src/core/seo/components/BrandDetailSchema";
import BaseThemeBrandProductsBrowser from "../components/BrandProductsBrowser/index";
import dynamic from "next/dynamic";
import {logModuleLoadError} from "src/core/common/utils";

const AdBanner = dynamic(() =>
  import("@themes/default/components/AdBanner").catch(logModuleLoadError("adBanner"))
);

export default function BaseThemeBrandPage(props) {
  const router = useRouter();
  const brandSlug = router.query["brand"];
  const [brand] = useBrand(brandSlug);
  const {showAdBanner} = useAdBanner();

  return (
    <BaseThemeBasePage {...props}>
      {brand && (
        <PageHead
          title={brand.getName()}
          description={brand.getDescription()}
          image={brand.getLogo()}
          schemas={<BrandDetailSchema brand={brand} />}
        />
      )}
      <PromotionalBanner />
      {showAdBanner && <AdBanner />}
      <BaseThemeBrandProductsBrowser showFilters showSort />
    </BaseThemeBasePage>
  );
}
